import React, { Suspense, lazy } from 'react';
import { NewHero } from '../sections/NewHero';
const NewHowItWorks = lazy(() => import('../sections/NewHowItWorks').then(m => ({
  default: m.NewHowItWorks
})));
const ForWhom = lazy(() => import('../sections/ForWhom').then(m => ({
  default: m.ForWhom
})));
const ComparisonTable = lazy(() => import('../sections/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const Simulator = lazy(() => import('../sections/Simulator').then(m => ({
  default: m.Simulator
})));
const SecurityFAQ = lazy(() => import('../sections/SecurityFAQ').then(m => ({
  default: m.SecurityFAQ
})));
const PreRegistration = lazy(() => import('../sections/PreRegistration').then(m => ({
  default: m.PreRegistration
})));
const SectionLoader = () => <div className="py-12 md:py-20 flex items-center justify-center" data-id="element-338">
    <div className="w-8 h-8 border-4 border-[#2B5FD9] border-t-transparent rounded-full animate-spin" data-id="element-339" />
  </div>;
export default function Home() {
  return <>
      <NewHero data-id="element-340" />
      <Suspense fallback={<SectionLoader data-id="element-342" />} data-id="element-341">
        <NewHowItWorks data-id="element-343" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-345" />} data-id="element-344">
        <ForWhom data-id="element-346" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-348" />} data-id="element-347">
        <ComparisonTable data-id="element-349" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-351" />} data-id="element-350">
        <Simulator data-id="element-352" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-354" />} data-id="element-353">
        <SecurityFAQ data-id="element-355" />
      </Suspense>
      <Suspense fallback={<SectionLoader data-id="element-357" />} data-id="element-356">
        <PreRegistration data-id="element-358" />
      </Suspense>
    </>;
}